import React from 'react'
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar'
import Search from '../Search'
import DistrictFilter from '../DistrictFilter'

const MobileSearchToolbar = () => (
  <Toolbar>
    <ToolbarGroup lastChild={true}>
      <Search />
      <DistrictFilter />
    </ToolbarGroup>
  </Toolbar>
)

export default MobileSearchToolbar



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondaryToolbars/MobileSearchToolbar.js